import { createFileRoute, redirect } from '@tanstack/react-router'
import { AppRoute, buildRoute } from 'appRoutes'
import { z } from 'zod/v4'

import { getLDFlag } from '../../../../../helpers/launchDarkly'

const rulesetSearchSchema = z.object({
  cfConnect: z.boolean().optional(),
})

export const Route = createFileRoute('/_authenticated/workspaces/$subscriptionId/rulesets/$rulesetId')({
  validateSearch: rulesetSearchSchema,
  beforeLoad: ({ params, context }) => {
    const canViewRulesetBuilder = getLDFlag('RULESETS_AND_FLOW', false, context.ldClient)
    if (!canViewRulesetBuilder) {
      throw redirect({
        to: buildRoute(AppRoute.SubscriptionOverview, { subscriptionId: params.subscriptionId }),
      })
    }
  },
})
